import React from 'react';

const RefundItem = ({ refund }) => {
  return (
    <tr>
      <td>{refund.id}</td>
      <td>{refund.sale_id}</td>
      <td>{refund.refund_date}</td>
      <td>{refund.total_refund}</td>
      <td>{refund.cancellation_fee}</td>
      <td>{refund.loss_amount}</td>
      <td>{refund.status}</td>
      <td>{refund.notes}</td>
    </tr>
  );
};

export default RefundItem;
